

// Oh wouldn't it be nice if the product catalog had an API so this could be imported from there? 
// Whishfull thinking!

const equipmentCatalog = {
  ConferencingBars: [
    {
      modelName: 'Parlé ABC 2500a',
      partNumber: '911.1968.900',
      description: 'Conferencing audio bar with ALS port.',
    },
    {
      modelName: 'Parlé VBC 2500a',
      partNumber: '911.1967.900',
      hasCamera: true,
      description: 'Conferencing video bar with ALS port.',
    },
    {
      modelName: 'Parlé VBC 2800',
      partNumber: '911.1987.900',
      hasCamera: true,
      dualImager: true,
      description: 'All-in-one conferencing video bar with dual-imager camera and ALS port.',
    },
    {
      modelName: 'Parlé CBC 2500 CM',
      partNumber: '911.XXXX.900',
      hasCamera: true,
      description: 'Conferencing video bar with cable mount and ALS port.',
    },
    {
      modelName: 'Parlé CBC 2500 PM',
      partNumber: '911.XXXX.901',
      description: 'Conferencing audio bar with pole mount and ALS port.',
    },
  ],

  Microphones: [
    // Ceiling mics
    {
      modelName: "Parlé TCM-XA",
      partNumber: "910.0499.900",
      isAmpUnit: true,
      description: "AVB Beamtracking, surface-mount ceiling microphone with PoE+ amplifier.",
    },
    {
      modelName: "Parlé TCM-X",
      partNumber: "911.0498.900",
      isBaseUnit: true,
      description: "AVB Beamtracking, surface-mount ceiling microphone.",
    },
    {
      modelName: "Parlé TCM-XEX",
      partNumber: "910.0500.900",
      isExpanderUnit: true,
      description: "Expansion AVB Beamtracking, surface-mount ceiling microphone.",
    },
    // Devio (Tree Frog) ceiling mic family — WDT-89 placeholders. Mirrors the Parlé
    // TCM-X / TCM-XA / TCM-XEX shape but routed via the UCC's Ethernet peripheral
    // ports. partNumber is a stub until the official SKUs land — swap them in place
    // and the code keeps working because lookups are by modelName.
    //
    // Port budget (WDT-89 AC #5): each Ethernet mic chain consumes 1 UCC peripheral
    // port. A ceiling chain = 1 base + up to 1 expansion head (2 mic elements).
    // DCM-XA serves dual purpose: chain entry point AND integrated amplifier (so a
    // DCM-XA chain provides amp capacity without burning a second port on a
    // standalone amp). Capacity values are stored on the catalog entry so the port
    // budget model can read them in one place.
    {
      modelName: "Parlé DCM-XA",
      partNumber: "DCM-XA",
      isAmpUnit: true,
      isBaseUnit: true,
      productFamily: 'Devio',
      isTreeFrog: true,
      consumesPeripheralPort: true,
      ampChannels: 2,
      ampSpeakersPerChannel: 2,
      ampCapacity: 4,
      description: "Devio UCX Beamtracking, surface mount ceiling microphone with PoE+ amplifier",
    },
    {
      modelName: "Parlé DCM-X",
      partNumber: "DCM-X",
      isBaseUnit: true,
      productFamily: 'Devio',
      isTreeFrog: true,
      consumesPeripheralPort: true,
      description: "Devio UCX Beamtracking, surface mount ceiling microphone",
    },
    {
      modelName: "Parlé DCM-XEX",
      partNumber: "DCM-XEX",
      isExpanderUnit: true,
      productFamily: 'Devio',
      isTreeFrog: true,
      description: "Expansion Devio UCX Beamtracking, surface mount ceiling microphone",
    },
    // pendant mics
    {
      modelName: "Parlé TCM-1A",
      partNumber: "911.0486.900",
      isPendant: true,
      isAmpUnit: true,
      description: "AVB Beamtracking pendant microphone with PoE+ amplifier.",
    },
    {
      modelName: "Parlé TCM-1 pendant",
      partNumber: "911.0485.900",
      isPendant: true,
      isBaseUnit: true,
      description: "AVB Beamtracking ceiling microphone.",
    },
    {
      modelName: "Parlé TCM-1EX",
      partNumber: "911.0487.900",
      isPendant: true,
      isExpanderUnit: true,
      description: "Pendant ceiling microphone",
    },
    // Tabletop mics
    {
      modelName: "Parlé TTM-X",
      partNumber: "910.0510.900",
      isTableTop: true,
      isBaseUnit: true,
      description: "AVB Beamtracking, tabletop microphone.",
    },
    {
      modelName: "Parlé TTM-XEX",
      partNumber: "910.0511.900",
      isTableTop: true,
      isExpanderUnit: true,
      description: "Expansion AVB Beamtracking, tabletop microphone.",
    },
    // Devio (Tree Frog) table mic family — mirrors the Parlé TTM-X / TTM-XEX
    // shape but routes via the UCC's Ethernet peripheral ports. partNumber is a
    // stub until the official SKUs land. Note the chain capacity (2 mic elements
    // per chain — base + up to 1 expander) is encoded in `treeFrogPorts.js` as
    // `TABLE_CHAIN_MAX_MICS`.
    //
    // Unlike ceiling (DCM-X/XA/XEX), table expansion mics have no amplified
    // variant — DTM-X does not amplify speakers. Speakers on a table-mic design
    // always route through the standalone Devio DPA-450BP.
    {
      modelName: "Parlé DTM-X",
      partNumber: "DTM-X",
      isTableTop: true,
      isBaseUnit: true,
      productFamily: 'Devio',
      isTreeFrog: true,
      consumesPeripheralPort: true,
      description: "Devio UCX Beamtracking tabletop microphone",
    },
    {
      modelName: "Parlé DTM-XEX",
      partNumber: "DTM-XEX",
      isTableTop: true,
      isExpanderUnit: true,
      productFamily: 'Devio',
      isTreeFrog: true,
      description: "Expansion Devio UCX Beamtracking tabletop microphone",
    },
    // Ceiling tile beamforming mics (Dante-based, on-board DSP).
    // PIG-420: order matters — getMicrophones uses .includes() for catalog lookup,
    // so "BMA360D" must precede "BMA360D-I" (otherwise a "BMA360D" query would
    // substring-match the 600mm entry first).
    {
      modelName: "BMA360D",
      partNumber: "BMA360D",
      isCeilingTile: true,
      isBaseUnit: true,
      description: "BMA360D ceiling tile beamforming microphone, 24\" tile (Dante).",
    },
    {
      modelName: "BMA360D-I",
      partNumber: "BMA360D-I",
      isCeilingTile: true,
      isBaseUnit: true,
      description: "BMA360D-I ceiling tile beamforming microphone, 600mm tile (Dante).",
    },
  ],

  Speakers: [
    {
      modelName: 'Desono C-IC6 (units)',
      partNumber: '911.0925.900',
      bundleCode: 'CIC6',
      description: 'In-ceiling, indoor, 6.5-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Desono C-IC6 LP',
      partNumber: '911.0926.900',
      bundleCode: 'CIC6LP',
      description: 'Low-profile in-ceiling loudspeaker.'
    },
    {
      modelName: 'Desono C-IC6 LP-TAA',
      partNumber: '911.0927.900',
      bundleCode: 'CIC6LP-TAA',
      description: 'TAA compliant low-profile in-ceiling loudspeaker.'
    },
    {
      modelName: 'Desono C-IC6LP (units)',
      partNumber: '911.0925.900',
      bundleCode: 'CIC6LP',
      description: 'In-ceiling, indoor, low-profile, 6.5-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Desono C-IC6LP-TAA (units)',
      partNumber: '911.0925.901',
      bundleCode: 'CIC6LP-TAA',
      description: 'In-ceiling, indoor, low-profile, 6.5-inch, coaxial loudspeaker, TAA compliant (priced individually, sold in pairs).'
    },
    {
      modelName: 'Parlé P6-SM',
      partNumber: '911.0928.900',
      bundleCode: 'P6SM',
      description: 'Surface mount loudspeaker for meeting rooms.'
    },
    {
      modelName: 'Desono P6-SM (units)',
      partNumber: '911.1212.900',
      bundleCode: 'P6SM',
      description: 'Pendant-mount, indoor, 6.5-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Desono DXS5',
      partNumber: '911.0929.900',
      bundleCode: 'DXS5',
      description: '5-inch in-ceiling loudspeaker.'
    },
    {
      modelName: 'Desono DX-S5 (units)',
      partNumber: '911.1205.900',
      bundleCode: 'DXS5',
      description: 'Surface-mount, indoor/outdoor, 5.25-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Desono DX-S8',
      partNumber: '911.1206.900',
      description: 'Surface-mount, indoor/outdoor, 8-inch, coaxial loudspeaker.'
    },
    {
      modelName: 'Desono DX-S8 (units)',
      partNumber: '911.1206.900',
      description: 'Surface-mount, indoor/outdoor, 8-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Desono ENT206',
      partNumber: '911.0930.900',
      bundleCode: 'ENT206',
      description: '6-inch in-ceiling loudspeaker.'
    },
    {
      modelName: 'Desono EX-S6',
      partNumber: '911.1207.900',
      description: 'Surface-mount, indoor/outdoor, 6-inch, coaxial loudspeaker.'
    },
    {
      modelName: 'Desono EX-S6 (units)',
      partNumber: '911.1207.900',
      description: 'Surface-mount, indoor/outdoor, 6-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Desono EXS8',
      partNumber: '911.0931.900',
      bundleCode: 'EXS8',
      description: '8-inch in-ceiling loudspeaker.'
    },
    {
      modelName: 'Desono EX-S8 (units)',
      partNumber: '911.1208.900',
      bundleCode: 'EXS8',
      description: 'Surface-mount, indoor/outdoor, 8-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'Community MASK6C',
      partNumber: '911.0932.900',
      bundleCode: 'MASK6C',
      description: 'Masked 6-inch ceiling loudspeaker.'
    },
    {
      modelName: 'Desono MASK6C',
      partNumber: '911.0932.900',
      bundleCode: 'MASK6C',
      description: 'Masked 6-inch ceiling loudspeaker.'
    },
    {
      modelName: 'Desono MASK6C (units)',
      partNumber: '911.0932.900',
      bundleCode: 'MASK6C',
      description: 'Masked 6-inch ceiling loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'TesiraSCIP-T',
      partNumber: '911.0933.900',
      bundleCode: 'TSC2DIP-T',
      description: 'Tesira IP endpoint tabletop speaker.'
    },
    {
      modelName: 'TesiraSCIP-Z',
      partNumber: '911.0934.900',
      bundleCode: 'TSC2DIP-Z',
      description: 'Tesira IP endpoint zone speaker.'
    },
    {
      modelName: 'H10-G',
      partNumber: '911.1627.900',
      description: 'Compact industrial horn speaker'
    },
    {
      modelName: 'H20-G',
      partNumber: '911.1628.900',
      description: 'Weatherproof industrial horn speaker'
    },
    {
      modelName: 'H30LT-G',
      partNumber: '911.1629.900',
      description: 'Long throw horn speaker'
    },
    {
      modelName: 'MPLT62-G',
      partNumber: '911.1428.900',
      description: '2-way, long throw music projector horn speaker'
    },
    {
      modelName: 'R.25-94TZ',
      partNumber: '911.1236.900',
      description: 'Full-range, two-way coaxial 90°X40° horn speaker w/transformer'
    },
    {
      modelName: 'R.5-94TZ',
      partNumber: '911.1247.900',
      description: 'Full-range, two-way sound projector w/transformer'
    },
    {
      modelName: 'R.35-3896',
      partNumber: '910.0301.900',
      description: 'Full-range, triaxial three-way loudspeaker'
    },
    {
      modelName: 'R.15-3696',
      partNumber: '910.2264.900',
      description: 'Full-range, triaxial three-way loudspeaker'
    },
    {
      modelName: 'CCA-80',
      partNumber: '910.2265.900',
      description: 'Constant coverage, triaxial aisle loudspeaker'
    },
    {
      modelName: 'CCA-80D',
      partNumber: '950.2266.900',
      description: 'Dual, back-to-back, constant coverage, triaxial aisle loudspeaker'
    },
  ],

  Cameras: [
    {
      modelName: "Vidi 250",
      partNumber: "910.0130.900",
      description: "Wide angle 4K conferencing camera",
    },
    {
      modelName: "Vidi 280",
      partNumber: "910.0131.900",
      description: "Dual-imager 4K conferencing camera with wide-angle and zoom capabilities",
      dualImager: true,
    },
  ],

  Processors: [
    // Tesira DSP ordered in ascending capacity
    {
      modelName: 'TesiraFORTÉ X 400',
      partNumber: '910.1803.900',
      description: 'Meeting Room DSP with 4 channels of AEC.',
      productFamily: 'Tesira',
      capacity: 4
    },
    {
      modelName: 'TesiraFORTÉ X 800',
      partNumber: '911.0092.900',
      description: 'Meeting Room DSP with 8 channels of AEC.',
      productFamily: 'Tesira',
      capacity: 8
    },
    {
      modelName: 'TesiraFORTÉ X 1600',
      partNumber: '911.0093.900',
      description: 'Meeting Room DSP with 16 channels of AEC.',
      productFamily: 'Tesira',
      capacity: 16
    },
    // Devio DSP ordered in ascending capacity
    {
      modelName: 'Devio SCX 400',
      partNumber: '910.1798.900',
      description: 'Conference room hub and audio DSP with 4 channels of AEC.',
      productFamily: 'Devio',
      capacity: 4
    },
    {
      modelName: 'Devio SCX 800',
      partNumber: '911.0090.900',
      description: 'Conference room hub and audio DSP with 8 channels of AEC.',
      productFamily: 'Devio',
      capacity: 8
    },
  ],

  Amplifiers: [
    {
      modelName: 'Tesira AMP-450BP',
      partNumber: '911.0014.900',
      description: 'Four-channel PoE+ speaker mounted amplifier.'
    },
    // Devio (Tree Frog) PoE amplifier — WDT-89 placeholder. partNumber is a stub
    // until the official SKU lands. Per WDT-89 AC #8 this is the only valid amplifier
    // for Tree Frog Ethernet peripheral configurations. Occupies 1 UCC peripheral
    // port (AC #5). Capacity is 4 channels × 2 speakers = 8 speakers.
    {
      modelName: 'Devio DPA-450BP',
      partNumber: 'DPA-450BP',
      productFamily: 'Devio',
      isTreeFrog: true,
      consumesPeripheralPort: true,
      ampChannels: 4,
      ampSpeakersPerChannel: 2,
      ampCapacity: 8,
      description: 'Devio UCX four-channel PoE+ speaker mounted amplifier'
    }
  ],

  Switches: [
    {
      modelName: 'TesiraCONNECT TC-5',
      partNumber: '912.0039.900',
      description: '5-port connection device.'
    },
    {
      modelName: 'Biamp NMS-NG10GPX-AVB',
      partNumber: '911.1966.900',
      description: 'AVB-enabled Netgear 10-port 1G switch',
      ports: 8,
    },
    {
      modelName: 'Biamp NMS-NG26GPX-AVB',
      partNumber: '911.1976.900',
      description: 'AVB-enabled Netgear 26-port 1G switch',
      ports: 24,
    },
  ],

  Cables: [
    {
      modelName: 'EasyConnect C5E-3',
      partNumber: '909.1802.900',
      description: '3-foot (0.9-meter) CAT5e cable',
      length: "3'"
    },
    {
      modelName: 'EasyConnect C5E-10-P',
      partNumber: '909.1801.900',
      description: '10-foot (3-meter) plenum rated CAT5e cable',
      length: "10'"
    },
    {
      modelName: 'EasyConnect C5E-25-P',
      partNumber: '909.1800.900',
      description: '25-foot (7.6-meter) plenum rated CAT5e cable',
      length: "25'"
    },

  ],

  Accesories: [
    {
      modelName: 'BPAK',
      partNumber: '910.0912.900',
      description: 'Backpack adapter kit'
    },
    {
      modelName: 'PMA 2000-DM',
      partNumber: '909.0089.900',
      description: 'Display mount for wall-mounted conferencing bars'
    },
    {
      modelName: 'DCC-Kit',
      // Keyed by model identifier (as with TCM-X-PM) until the numeric SKU is assigned.
      // The CBC 2500 accessory SKUs live on the cloud CLM "Equipment Calculation Logic
      // Baseline" page (§4.6 Accessories); swap in the 909.xxxx.xxx value when available.
      partNumber: 'DCC-Kit',
      description: 'Decorative Cover Kit for CBC-2500 CM cable management'
    },
    {
      modelName: 'PMA-2000-PE',
      partNumber: 'PMA-2000-PE',
      description: '3 foot pole extension for CBC-2500 PM',
      length: 0.9144, // 3 feet in meters
      type: 'pm_extension'
    },
    {
      // PIG-454 / PIG-450 / PIG-453 (WDT-138/139/142): CCA adapter (Euroblock→Cat5e) used to
      // connect wall speakers, P6-SM pendant speakers, and TCM-1A amplifier outputs. Keyed by
      // identifier until the numeric SKU is assigned (mirrors DCC-Kit / PMA-2000-PE); the SKU
      // lives on the cloud CLM "Equipment Calculation Logic Baseline" page (§4.6 Accessories).
      modelName: 'CCA',
      partNumber: 'CCA',
      description: 'CCA adapter (Euroblock to Cat5e) for speaker / amplifier connections'
    },
    // Apprimo Touch 10 UCX-T tabletop touch console — MVP scope. UCX-W wall variant
    // is post-MVP. Tagged with `productFamily: 'Devio'` + `isTreeFrog: true` so
    // platform filtering can match it to UCX hub designs.
    {
      modelName: 'Apprimo Touch 10 UCX-T',
      partNumber: 'TOUCH-10-UCX-T',
      description: '10" tabletop touch console for Devio UCX Microsoft Teams Rooms and Zoom Rooms.',
      productFamily: 'Devio',
      isTreeFrog: true,
    },
    // EasyConnect POE-90W — PoE++ injector that powers the BMA360D
    // on-board amplifier. Added only when the on-board amp drives C-IC6 or pendant
    // speakers (escalation remainder 1–4). NOT added for wall speakers: in a wall
    // design the BMA360D is powered via PoE+ from the Forte DSP, so no injector.
    // TODO: confirm partNumber against the EasyConnect POE-90W SKU.
    {
      modelName: 'EasyConnect POE-90W',
      partNumber: '910.3200.209',
      isPoeInjector: true,
      description: 'PoE++ injector (EasyConnect POE-90W) powering the BMA360D on-board amplifier.'
    }
  ],

  PoleAccessories: [
    {
      modelName: 'TCM-X-PM',
      partNumber: 'TCM-X-PM',
      description: 'TCM-X Pipe mounting kit',
      length: 1.042, // 3'5" in meters (base pole maximum distance)
      type: 'tcm_x_base_pole',
      maxDistance: 1.042 // Maximum distance this accessory can cover
    },
    {
      modelName: 'PMA-2000-PE',
      partNumber: 'PMA-2000-PE',
      description: '3-foot pole extension',
      length: 0.9144, // 3.0 feet in meters
      type: 'tcm_x_extension'
    },
    {
      modelName: 'Ceiling Mount Pole 0.5ft',
      partNumber: 'CMP-05',
      description: '0.5 foot ceiling mount pole section',
      length: 0.1524, // 0.5 feet in meters
      type: 'base_pole',
      minMountingHeight: 0.1524 // Minimum mounting height (0.5ft)
    },
    {
      modelName: 'Pole Extension 1.0ft',
      partNumber: 'PE-10',
      description: '1.0 foot pole extension',
      length: 0.3048, // 1.0 feet in meters
      type: 'extension'
    },
    {
      modelName: 'Pole Extension 1.5ft',
      partNumber: 'PE-15',
      description: '1.5 foot pole extension',
      length: 0.4572, // 1.5 feet in meters
      type: 'extension'
    },
    {
      modelName: 'Pole Extension 2.0ft',
      partNumber: 'PE-20',
      description: '2.0 foot pole extension',
      length: 0.6096, // 2.0 feet in meters
      type: 'extension'
    },
    {
      modelName: 'Pole Extension 3.0ft',
      partNumber: 'PE-30',
      description: '3.0 foot pole extension',
      length: 0.9144, // 3.0 feet in meters
      type: 'extension'
    }
  ],

  Bundles: [
    // Tesira X400 bundles with CIC6 speakers
    {
      modelName: 'Biamp MRB-M-X400-C-CIC6',
      partNumber: '950.1804.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Tesira',
      bundleSize: 'M',
      micType: 'C',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'TCM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
        dsp: 'TesiraFORTÉ X 400'
      }
    },
    {
      modelName: 'Biamp MRB-M-X400-T-CIC6',
      partNumber: '950.1806.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TTM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2
      }
    },
    {
      modelName: 'Biamp MRB-L-X400-C-CIC6',
      partNumber: '950.1805.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4
      }
    },
    {
      modelName: 'Biamp MRB-L-X400-T-CIC6',
      partNumber: '950.1807.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TTM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4
      }
    },
    // Devio SCX400 bundles with CIC6 speakers
    {
      modelName: 'Biamp MRB-M-SCX400-C',
      partNumber: '950.1790.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Devio',
      bundleSize: 'M',
      micType: 'C',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'TCM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
        dsp: 'Devio SCX 400'
      }
    },
    {
      modelName: 'Biamp MRB-M-SCX400-T',
      partNumber: '950.1792.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Devio',
      bundleSize: 'M',
      micType: 'T',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'TTM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
        dsp: 'Devio SCX 400'
      }
    },
    {
      modelName: 'Biamp MRB-L-SCX400-C',
      partNumber: '950.1791.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Devio',
      bundleSize: 'L',
      micType: 'C',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4,
        dsp: 'Devio SCX 400'
      }
    },
    {
      modelName: 'Biamp MRB-L-SCX400-T',
      partNumber: '950.1793.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Devio',
      bundleSize: 'L',
      micType: 'T',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'TTM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4,
        dsp: 'Devio SCX 400'
      }
    },
    
    // VBC 2800 UC Compute bundles
    {
      modelName: 'Biamp MRB-M-VBC2800-C-CIC6',
      partNumber: '950.2810.900',
      description: 'UC Compute meeting room bundle for medium rooms with ceiling mics.',
      productFamily: 'Tesira',
      bundleSize: 'M',
      micType: 'C',
      speakerCode: 'CIC6',
      requiresUCCompute: true,
      includes: {
        micModel: 'TCM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
        dsp: 'VBC 2800',
        ucCompute: true
      }
    },
    {
      modelName: 'Biamp MRB-L-VBC2800-C-CIC6',
      partNumber: '950.2811.900',
      description: 'UC Compute meeting room bundle for large rooms with ceiling mics.',
      productFamily: 'Tesira',
      bundleSize: 'L',
      micType: 'C',
      speakerCode: 'CIC6',
      requiresUCCompute: true,
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4,
        dsp: 'VBC 2800',
        ucCompute: true
      }
    },
    {
      modelName: 'Biamp MRB-M-VBC2800-T-CIC6',
      partNumber: '950.2812.900',
      description: 'UC Compute meeting room bundle for medium rooms with tabletop mics.',
      productFamily: 'Tesira',
      bundleSize: 'M',
      micType: 'T',
      speakerCode: 'CIC6',
      requiresUCCompute: true,
      includes: {
        micModel: 'TTM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
        dsp: 'VBC 2800',
        ucCompute: true
      }
    },
    {
      modelName: 'Biamp MRB-L-VBC2800-T-CIC6',
      partNumber: '950.2813.900',
      description: 'UC Compute meeting room bundle for large rooms with tabletop mics.',
      productFamily: 'Tesira',
      bundleSize: 'L',
      micType: 'T',
      speakerCode: 'CIC6',
      requiresUCCompute: true,
      includes: {
        micModel: 'TTM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4,
        dsp: 'VBC 2800',
        ucCompute: true
      }
    },

    // Platform-specific bundles with TS2CIP speakers (Teams and Zoom)
    {
      modelName: 'Biamp MRB-L-X400-C-TSC2DIP-T',
      partNumber: '930-00034',
      description: 'Certified meeting room bundle for large rooms with Microsoft Teams (up to 18 participants).',
      productFamily: 'Tesira',
      bundleSize: 'L',
      micType: 'C',
      speakerCode: 'TSC2DIP-T',
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'TesiraSCIP-T',
        spkrQty: 4,
        dsp: 'TesiraFORTÉ X 400'
      }
    },
    {
      modelName: 'Biamp MRB-L-X400-C-TSC2DIP-Z',
      partNumber: '930-00035',
      description: 'Certified meeting room bundle for large rooms with Zoom Rooms (up to 18 participants).',
      productFamily: 'Tesira',
      bundleSize: 'L',
      micType: 'C',
      speakerCode: 'TSC2DIP-Z',
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'TesiraSCIP-Z',
        spkrQty: 4,
        dsp: 'TesiraFORTÉ X 400'
      }
    },
    {
      modelName: 'Biamp MRB-VBC 2800-TSC2DIP-T',
      partNumber: '930-00032',
      description: 'UC Compute meeting room bundle with VBC 2800 for Microsoft Teams.',
      productFamily: 'Parlé',
      bundleSize: 'L',
      requiresUCCompute: true,
      speakerCode: 'TSC2DIP-T',
      includes: {
        dsp: 'VBC 2800',
        spkrModel: 'TesiraSCIP-T',
        spkrQty: 4,
        ucCompute: true
      }
    },
    {
      modelName: 'Biamp MRB-VBC 2800-TSC2DIP-Z',
      partNumber: '930-00033',
      description: 'UC Compute meeting room bundle with VBC 2800 for Zoom Rooms.',
      productFamily: 'Parlé',
      bundleSize: 'L',
      requiresUCCompute: true,
      speakerCode: 'TSC2DIP-Z',
      includes: {
        dsp: 'VBC 2800',
        spkrModel: 'TesiraSCIP-Z',
        spkrQty: 4,
        ucCompute: true
      }
    },
    {
      modelName: 'Biamp MRB-VBC 2500a-TSC2DIP-T',
      partNumber: '930-00030',
      description: 'UC Compute meeting room bundle with VBC 2500a for Microsoft Teams.',
      productFamily: 'Parlé',
      bundleSize: 'L',
      requiresUCCompute: true,
      speakerCode: 'TSC2DIP-T',
      includes: {
        dsp: 'VBC 2500a',
        spkrModel: 'TesiraSCIP-T',
        spkrQty: 4,
        ucCompute: true
      }
    },
        {
      modelName: 'Biamp MRB-VBC 2500a-TSC2DIP-Z',
      partNumber: '930-00031',
      description: 'UC Compute meeting room bundle with VBC 2500a for Zoom Rooms.',
      productFamily: 'Parlé',
      bundleSize: 'L',
      requiresUCCompute: true,
      speakerCode: 'TSC2DIP-Z',
      includes: {
        dsp: 'VBC 2500a',
        spkrModel: 'TesiraSCIP-Z',
        spkrQty: 4,
        ucCompute: true
      }
    },

    // ─────────────────────────────────────────────────────────────────────────
    // Devio UCX (Tree Frog) bundles. partNumbers are placeholders until the
    // official SKUs land. Tagged with `productFamily: 'Devio'` + `isTreeFrog: true`
    // so platform filtering can route these to UCX designs only and leave Tesira /
    // Devio SCX designs unaffected.
    //
    // Two flavours per the spec:
    //   - Compute bundles (UCC-UCX*-T): UCX hub + Touch console, used à la carte
    //     when the user adds Android UC compute to an existing audio system.
    //   - Room bundles (MRB-UCX*): full room configurations (hub + console + bar
    //     and/or mics + speakers). The UCX 3000 bar-only variants
    //     (MRB-UCX3000T-VBC2800, -DCMX, -DTMX) are listed but not yet matched by
    //     Designer's bundle-selection logic — UCX 2000 equivalents win today; per
    //     spec this is a planned capability and the 3000 entries stay for future use.
    // ─────────────────────────────────────────────────────────────────────────

    // Compute bundles — UCX hub + Apprimo Touch 10 console only.
    {
      modelName: 'Biamp UCC-UCX1000-T',
      partNumber: 'UCC-UCX1000-T',
      description: 'Android UC Room System with Devio UCX 1000 meeting room hub and touch panel',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 1000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
      },
    },
    {
      modelName: 'Biamp UCC-UCX2000-T',
      partNumber: 'UCC-UCX2000-T',
      description: 'Android UC Room System with Devio UCX 2000 meeting room hub and touch panel',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 2000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
      },
    },
    {
      modelName: 'Biamp UCC-UCX3000-T',
      partNumber: 'UCC-UCX3000-T',
      description: 'Android UC Room System with Devio UCX 3000 meeting room hub and touch panel',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
      },
    },

    // Room bundles — full room configurations.

    // UCX 1000 + bar (USB peripherals only — no DCM-X / DTM-X variants).
    {
      modelName: 'Biamp MRB-UCX1000T-VBC2500a',
      partNumber: 'MRB-UCX1000T-VBC2500a',
      description: 'Complete meeting room bundle with Android UC system for small to medium rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 1000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2500a',
      },
    },
    {
      modelName: 'Biamp MRB-UCX1000T-VBC2800',
      partNumber: 'MRB-UCX1000T-VBC2800',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 1000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2800',
      },
    },

    // UCX 2000 + bar + Ethernet mic chain.
    {
      modelName: 'Biamp MRB-UCX2000T-VBC2800-DCMX',
      partNumber: 'MRB-UCX2000T-VBC2800-DCMX',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 2000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2800',
        micModel: 'DCM-X',
        micQty: 1,
      },
    },
    {
      modelName: 'Biamp MRB-UCX2000T-VBC2800-DTMX',
      partNumber: 'MRB-UCX2000T-VBC2800-DTMX',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 2000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2800',
        micModel: 'DTM-X',
        micQty: 1,
      },
    },

    // UCX 3000 + bar — defined but not yet matched by Designer's bundle-select
    // logic (UCX 2000 equivalents win today; future capability per spec).
    {
      modelName: 'Biamp MRB-UCX3000T-VBC2800',
      partNumber: 'MRB-UCX3000T-VBC2800',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2800',
      },
    },
    {
      modelName: 'Biamp MRB-UCX3000T-VBC2800-DCMX',
      partNumber: 'MRB-UCX3000T-VBC2800-DCMX',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2800',
        micModel: 'DCM-X',
        micQty: 1,
      },
    },
    {
      modelName: 'Biamp MRB-UCX3000T-VBC2800-DTMX',
      partNumber: 'MRB-UCX3000T-VBC2800-DTMX',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        bar: 'VBC 2800',
        micModel: 'DTM-X',
        micQty: 1,
      },
    },

    // UCX 3000 + standalone camera + Ethernet mic chain + ceiling speakers (no bar).
    {
      modelName: 'Biamp MRB-UCX3000T-VIDI280-DCMX-2CIC6',
      partNumber: 'MRB-UCX3000T-VIDI280-DCMX-2CIC6',
      description: 'Complete meeting room bundle with Android UC system for small to medium rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        camera: 'Vidi 280',
        micModel: 'DCM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
      },
    },
    {
      modelName: 'Biamp MRB-UCX3000T-VIDI280-DTMX-2CIC6',
      partNumber: 'MRB-UCX3000T-VIDI280-DTMX-2CIC6',
      description: 'Complete meeting room bundle with Android UC system for small to medium rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        camera: 'Vidi 280',
        micModel: 'DTM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2,
      },
    },
    {
      modelName: 'Biamp MRB-UCX3000T-VIDI280-2DCMX-4CIC6',
      partNumber: 'MRB-UCX3000T-VIDI280-2DCMX-4CIC6',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        camera: 'Vidi 280',
        micModel: 'DCM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4,
      },
    },
    {
      modelName: 'Biamp MRB-UCX3000T-VIDI280-2DTMX-4CIC6',
      partNumber: 'MRB-UCX3000T-VIDI280-2DTMX-4CIC6',
      description: 'Complete meeting room bundle with Android UC system for medium to large rooms',
      productFamily: 'Devio',
      isTreeFrog: true,
      requiresUCCompute: true,
      includes: {
        ucCompute: 'Devio UCX 3000',
        touchConsole: 'Apprimo Touch 10 UCX-T',
        camera: 'Vidi 280',
        micModel: 'DTM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4,
      },
    },

    // ─────────────────────────────────────────────────────────────────────────
    // BMA360D bundles (PIG-516 / WDT-76). A single BMA360D unit + Forte X800/X1600
    // + 2 or 4 Desono C-IC6 speakers driven by the BMA on-board amp (no external
    // AMP-450BP). Each bundle includes 1× EasyConnect POE-90W, CCA (1× per speaker)
    // and Cat5e cables. Matched by matchBma360dBundle (bma360dDsp.ts): BMA variant
    // + DSP + C-IC6 + strict speaker quantity. `includes` is descriptive metadata —
    // the bundle is a single BOM line item. `partNumber` is a placeholder until the
    // SKU is assigned (mirrors the BMA360D mic catalog entries). The "CCA" adapter
    // (Euroblock→Cat5e) is not yet a distinct catalog SKU; it is noted here only.
    // ─────────────────────────────────────────────────────────────────────────
    {
      modelName: 'Biamp MRB-M-X800-BMA360D-CIC6',
      partNumber: 'MRB-M-X800-BMA360D-CIC6',
      description: 'Certified meeting room bundle with BMA ceiling tile mic (24”) for medium rooms',
      productFamily: 'Tesira',
      bundleSize: 'M',
      bmaModel: 'BMA360D',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'BMA360D',
        micQty: 1,
        dsp: 'TesiraFORTÉ X 800',
        spkrModel: 'C-IC6',
        spkrQty: 2,
        poeInjector: 'EasyConnect POE-90W',
        poeInjectorQty: 1,
        ccaQty: 2,
        cat5e10ftQty: 2,
        cat5e25ftQty: 1,
        cat5e3ftQty: 1,
      },
    },
    {
      modelName: 'Biamp MRB-L-X1600-BMA360D-CIC6',
      partNumber: 'MRB-L-X1600-BMA360D-CIC6',
      description: 'Certified meeting room bundle with BMA ceiling tile mic (24”) for large rooms',
      productFamily: 'Tesira',
      bundleSize: 'L',
      bmaModel: 'BMA360D',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'BMA360D',
        micQty: 1,
        dsp: 'TesiraFORTÉ X 1600',
        spkrModel: 'C-IC6',
        spkrQty: 4,
        poeInjector: 'EasyConnect POE-90W',
        poeInjectorQty: 1,
        ccaQty: 4,
        cat5e10ftQty: 4,
        cat5e25ftQty: 1,
        cat5e3ftQty: 1,
      },
    },
    {
      modelName: 'Biamp MRB-M-X800-BMA360DI-CIC6',
      partNumber: 'MRB-M-X800-BMA360DI-CIC6',
      description: 'Certified meeting room bundle with BMA ceiling tile mic (600mm) for medium rooms',
      productFamily: 'Tesira',
      bundleSize: 'M',
      bmaModel: 'BMA360D-I',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'BMA360D-I',
        micQty: 1,
        dsp: 'TesiraFORTÉ X 800',
        spkrModel: 'C-IC6',
        spkrQty: 2,
        poeInjector: 'EasyConnect POE-90W',
        poeInjectorQty: 1,
        ccaQty: 2,
        cat5e10ftQty: 2,
        cat5e25ftQty: 1,
        cat5e3ftQty: 1,
      },
    },
    {
      modelName: 'Biamp MRB-L-X1600-BMA360DI-CIC6',
      partNumber: 'MRB-L-X1600-BMA360DI-CIC6',
      description: 'Certified meeting room bundle with BMA ceiling tile mic (600mm) for large rooms',
      productFamily: 'Tesira',
      bundleSize: 'L',
      bmaModel: 'BMA360D-I',
      speakerCode: 'CIC6',
      includes: {
        micModel: 'BMA360D-I',
        micQty: 1,
        dsp: 'TesiraFORTÉ X 1600',
        spkrModel: 'C-IC6',
        spkrQty: 4,
        poeInjector: 'EasyConnect POE-90W',
        poeInjectorQty: 1,
        ccaQty: 4,
        cat5e10ftQty: 4,
        cat5e25ftQty: 1,
        cat5e3ftQty: 1,
      },
    },

  ],

  // UC Compute Devices
  UCCompute: [
    {
      modelName: 'UCC-Lenovo TSC2D-IP-MTR',
      partNumber: '920-00021',
      description: 'Lenovo UC compute device for Microsoft Teams Rooms.',
      platform: 'Microsoft Teams'
    },
    {
      modelName: 'UCC-Lenovo TSC2D-IP-Zoom',
      partNumber: '920-00020',
      description: 'Lenovo UC compute device for Zoom Rooms.',
      platform: 'Zoom Rooms'
    },
    // Devio UCX Android UC Room Hubs (Tree Frog). Three tiers differ in peripheral
    // protocol support and Teams/Zoom feature ceiling. partNumber is a placeholder
    // until the official SKUs land — lookups are by modelName so the swap is
    // a one-line rename.
    {
      modelName: 'Devio UCX 1000',
      partNumber: 'UCX-1000',
      description: 'Android UC Room Hub, USB peripherals only, entry level Teams and Zoom features.',
      productFamily: 'Devio',
      isTreeFrog: true,
    },
    {
      modelName: 'Devio UCX 2000',
      partNumber: 'UCX-2000',
      description: 'Android UC Room Hub, USB + Network peripherals, entry level Teams and Zoom features.',
      productFamily: 'Devio',
      isTreeFrog: true,
    },
    {
      modelName: 'Devio UCX 3000',
      partNumber: 'UCX-3000',
      description: 'Android UC Room Hub, USB + Network peripherals, dual displays, top tier Teams and Zoom capabilities.',
      productFamily: 'Devio',
      isTreeFrog: true,
    },
  ]

};

export default equipmentCatalog